import { FunnelContextArea } from "../components/funnel/types";
import { User } from "../types";

export function shouldShowOnboardingAfterAuth(
  userData: User,
  modalContext: FunnelContextArea,
): boolean {
  const isLandingPage = ["/gold", "/gifts", "/valkyrae"]
    .map((path) => window.location.pathname.startsWith(path))
    .includes(true);

  // Only show onboarding for specific contexts
  const allowedContexts = [
    FunnelContextArea.navBar,
    FunnelContextArea.startNextReleaseButton,
  ].includes(modalContext);

  const showOnboardingAfterAuth = allowedContexts && !isLandingPage;

  if (!showOnboardingAfterAuth) return false;

  const onboarding = userData.onboarding;
  const lastOnboardingAttempt = parseInt(
    localStorage.getItem("lastOnboardingTime") ?? "0",
  );
  const onboardingSkipped = userData.onboarding === "skipped";
  const ONE_DAY = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  const canShowOnboarding =
    !onboarding ||
    (onboardingSkipped && Date.now() - lastOnboardingAttempt > ONE_DAY);

  return canShowOnboarding;
}